import { useField } from 'react-final-form';
import styled from 'styled-components';
import { useState } from 'react';
import { CollapseIcon } from '../../../components/Icons/CollapseIcon';
import { ExpandIcon } from '../../../components/Icons/ExpandIcon';
import { TiresAllPhotos } from '../components/tires/tiresAllPhotos';
import { DefaultPhotosList } from './PhotosList';
import { AllPhotosSectionWrapper, AllPhotosHeader } from './ui';

type Props = {
  sectionId: string;
  collapsed?: boolean;
  theme?: 'grey' | 'white';
};

const IconWrapper = styled.div`
  display: flex;
`;

const fillColor = 'rgba(153, 153, 153, 1)';

const themeOptions = {
  white: {
    background: '#fff',
    gradeBackground: '#2222220A'
  },
  grey: {
    background: '#F5F5F5',
    gradeBackground: '#fff'
  }
};

export const AllPhotosSection = ({ sectionId, collapsed = false, theme = 'grey' }: Props) => {
  const {
    input: { value: label }
  } = useField(`${sectionId}.label`);

  const [isExpanded, setIsExpanded] = useState(!collapsed);

  const toggleExpanded = () => {
    setIsExpanded(c => !c);
  };

  const { background } = themeOptions[theme];

  const withBorder = theme === 'white';

  return (
    <AllPhotosSectionWrapper style={{ background }} withBorder={withBorder}>
      <AllPhotosHeader isExpanded={isExpanded} style={{ background }}>
        <IconWrapper onClick={toggleExpanded}>
          {isExpanded ? <CollapseIcon fillColor={fillColor} /> : <ExpandIcon fillColor={fillColor} />}
        </IconWrapper>
        <span>{`All ${label} Pictures`}</span>
      </AllPhotosHeader>
      {isExpanded &&
        (sectionId.includes('tires') ? (
          <TiresAllPhotos />
        ) : (
          <DefaultPhotosList background={background} sectionId={sectionId} />
        ))}
    </AllPhotosSectionWrapper>
  );
};
